import { get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { flow } from 'fp-ts/function';
import { getProp } from '@mews/fp';
import { getCurrentProfileId } from '@mews-commander/core';
import { moduleSelector } from '../module';
import { SUBMODULE_NAME_BOOKMARKS } from '../constants';
import AnalyticsType from '../enums/analyticsType';

const bookmarksSelector = flow(moduleSelector, (state) => state[SUBMODULE_NAME_BOOKMARKS]);

export const getCurrentAnalyticsCapturedBookmarks = createSelector(
    getProp<AnalyticsType>()('analyticsType'),
    bookmarksSelector,
    () => getCurrentProfileId(),
    (analyticsType, capturedBookmarks, profileId) => get([profileId, analyticsType])(capturedBookmarks)
);
